import React from 'react'

import { StyledContentWrapper } from 'component-library/compositions/ContentWrapper/ContentWrapper.styled'

export interface Props {
    stretchColumns?: boolean
    stretchSelf?: boolean
    fillContainer?: boolean
    hasBackgroundFill?: boolean
}

export const ContentWrapper: React.FC<Props> = ({
    children,
    stretchColumns,
    stretchSelf,
    fillContainer,
    hasBackgroundFill,
}) => (
    <StyledContentWrapper
        className="js-content-area"
        stretchColumns={stretchColumns}
        stretchSelf={stretchSelf}
        fillContainer={fillContainer}
        hasBackgroundFill={hasBackgroundFill}
    >
        {children}
    </StyledContentWrapper>
)
